export function filterList(value: any, args?: any): any {
    switch (args) {
        case 'string':
            return value.filter(element => element.type === 'string' || element.type === 'textarea' || element.type === 'picklist' || element.type === 'text' || element.type === 'email' || element.type === 'website' || element.type === 'url' || element.type === 'enumeration');
        case 'boolean':
            return value.filter(element => element.type === 'boolean');
        case 'enumeration':
            return value.filter(element => element.type === 'enumeration');
        case 'email':
            return value.filter(element => element.type === 'string' || element.type === 'textarea' || element.type === 'email' || element.type === 'text');
        case 'phone':
            return value.filter(element => element.type === 'string' || element.type === 'textarea' || element.type === 'phone' || element.type === 'text');
        case 'url':
            return value.filter(element => element.type === 'string' || element.type === 'textarea' || element.type === 'url' || element.type === 'text');
        case 'double':
            return value.filter(element => element.type === 'double' || element.type === 'currency' || element.type === 'string' || element.type === 'textarea' || element.type === 'money' || element.type === 'text');
        case 'int':
        case 'number':
            return value.filter(element => element.type === 'int' || element.type === 'integer' || element.type === 'double' || element.type === 'currency' || element.type === 'string' || element.type === 'textarea' || element.type === 'number' || element.type === 'money' || element.type === 'text');
        case 'date':
            return value.filter(element => element.type === 'date' || element.type === 'text' || element.type === 'textarea' || element.type === 'string');
        case 'datetime':
            return value.filter(element => element.type === 'datetime' || element.type === 'text' || element.type === 'textarea' || element.type === 'string');
    }
}